// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"85":"961ea738f3b092d9","315":"489957ab44d56c7c","844":"849c9935efc7b2f0"}[chunkId] + ".js";
};